<template>
  <div class="c-modal c-modal--reward-order t-modal is-visible">

    <section class="c-modal__box c-modal--reward-order__box">

      <div class="c-modal--reward-order__box__content">
        <h1 class="c-modal--reward-order__title t-headline">{{ $t('web.catalog_order_confirmation.sucess_message') }}</h1>
        <p class="c-modal--reward-order__confirmation-message u-paragraph u-center-text">{{ orderConfirmationMessage }}</p>
      </div>

      <div class="c-modal--reward-order__actions">
        <button class="c-button c-modal--reward-order__actions__button t-button-plain"
                @click="$emit('close')">
          {{ $t('web.catalog_order_confirmation.back_button') }}
        </button>
        <router-link class="c-button c-modal--reward-order__actions__button t-button-primary"
                     :to="{name: 'MyOrders'}"
                     tag="button" >
          {{ $t('web.catalog_order_confirmation.my_orders_link') }}
        </router-link>
      </div>

    </section>

    <div class="c-modal__overlay"></div>

  </div>
</template>





<script>
import { } from 'vuex'

export default {
  props: ['orderConfirmationMessage']
}
</script>



// WEBPACK FOOTER //
// OrderConfirmation.vue?497696ba